import { Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  helpUrl = "https://www.k2ss.fr";
  supportUrl = "mailto:support@cardsysa2z.com";

  constructor() { }

  ngOnInit() {  }

  navToUrl(toUrl : string) : void
  {
    location.href = toUrl ;
  }
}
